/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { TextInput } from '@carbon/react';

export function ClientCredentials({
  selectedCluster,
  clientId,
  setClientId,
  clientSecret,
  setClientSecret,
  isValidationEnabled
}) {
  const isClientIdInvalid = !clientId;
  const isClientSecretInvalid = !clientSecret;

  return (
    selectedCluster?.authentication === 'CLIENT_CREDENTIALS' && (
      <>
        <TextInput
          id="client-id-input"
          type="text"
          labelText="Client ID"
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          {...(isValidationEnabled &&
            isClientIdInvalid && { invalid: true, invalidText: 'Client ID must not be empty' })}
        />
        <TextInput
          id="client-secret-input"
          type="password"
          labelText="Client Secret"
          value={clientSecret}
          onChange={(e) => setClientSecret(e.target.value)}
          {...(isValidationEnabled &&
            isClientSecretInvalid && { invalid: true, invalidText: 'Client Secret must not be empty' })}
        />
      </>
    )
  );
}
